import { updateLinksAttributes } from '../../utils/handleAttributes';

export default function hotButtons() {
  const widgetName = 'hotButtons';
  const widgetOpts = hotButtonsOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: true,
    maxItemsVisible: 4,
    itemsPerPanel: 1,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createHotButtons(data.items, $widget);
      } else {
        $widget.remove();
      }
    },
  });
}

function createHotButtons(widgetData, $widget) {
  $widget.find('.card-widget-item').each(function (x) {
    const { Title, URL } = widgetData[x];
    const $hotButton = $(this);

    $hotButton.replaceWith(`
        <a ${URL == null || URL === '' ? '' : 'href="' + URL + '"'} class="hot-btn${URL == null || URL === '' ? ' void-link' : ''}" ${updateLinksAttributes(URL, Title)}>
          <span class="btn-texture"></span>
          <span class="btn-texture-hover"></span>
            ${createAbstractElement('top')}
              <span class="hot-btn-title">${Title}</span>
            ${createAbstractElement('bottom')}
        </a>
        `);

    updateLinksAttributes(URL, Title, $hotButton);
  });
}

function createAbstractElement(abstractClass) {
  return `
    <div class="abstract-star ${abstractClass}-star">
      <span class="icon"></span>
      <span class="icon"></span>
    </div>`;
}
